import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import defaultRemoveConfirmation from '@wix/da-shared-react/pkg/widgets/defaultRemoveConfirmation';
import GroupNotesBox from './GroupNotesBox';
import initActionsCreator from './redux/initModule';

export const getGroupNotesWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: GroupNotesBox,
  confirmRemove: () => defaultRemoveConfirmation({ t, dispatch }),
  widgetCard: {
    minuatureImageSrc:
      'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-17-groups.svg',
    title: t('widgets.group_notes.addButtonHeader'),
    description: t('widgets.group_notes.description'),
  },
  initActionsCreator,
});
export default getGroupNotesWidgetConfig;
